<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_BusinessStatusChangeLog')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'450px'}"
        />
        <!--      </div>
      <div slot="footer">
        <el-button size="mini" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
        </div>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { queryJobStateUpdateLog } from '@/api/seaExport/seaExportJob'

export default {
  name: 'BusinessStatusLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'operaterId', width: 150,
          cellRenderer: (params) => {
            if (params.value === -1) {
              return this.$t('CargoMsg.Cargo_SystemAutomaticExecution')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.operationContent'), field: 'operateName', width: 150 },
        { headerName: this.$t('FinanceManage.statusAfterOperation'), field: 'jobState', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateCN(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateTime'), field: 'operateTime', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('Clearing.BusinessCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      queryJobStateUpdateLog(this.jobUuid).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

